import React from 'react';

const Signup = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl text-center text-blue-600">Sign Up</h1>
      {/* Add your signup form here */}
    </div>
  );
};

export default Signup;